















import { Vue, Component, Prop } from 'vue-property-decorator';

import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';

@Component({ components: { StepTitle } })
export default class PasoAsociacion extends Vue {
  @Prop({}) title: string;
}
